export const DATE_RANGE_CUSTOM = 'custom';
